import { LuxIcon } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import './ReferenceInput.scss'

export interface ReferenceInputProps {
    placeholder: string
    isSelected?: boolean
    icon: string
    onChange: () => void
}

const ReferenceInput = ({ placeholder, isSelected, icon, onChange }: ReferenceInputProps) => {
    const intl = useIntl()
    const componentClass = 'smart-modals-reference-input'

    return (
        <div className={`${componentClass}`}>
            <div className={`${componentClass}__icon`}>
                <LuxIcon icon={icon} size={16}/>
            </div>
            <div className={`${componentClass}__label text ${isSelected ? 'isSelected' : ''}`}>
                {placeholder}
            </div>
            <div className={`${componentClass}__input link-mini`} onClick={onChange}>
                {intl.formatMessage({
                    id: 'modals.common.reference.input.change',
                    defaultMessage: 'Change',
                })}
            </div>
        </div>
    )
}

export default ReferenceInput
